













import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openList } from '@/main/router/routerPath';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { NAME } from './constants';
import { store } from '../store/edit';


export default EditStoreMixin.extend({
	name: 'PneuCard',
	data() {
		return {
			NAME,
		};
	},
	computed: {
		...genVuexComputeds(store),
		pneu(): string {
			return NAME;
		},
	},
	methods: {
		onPneuListClick() {
			openList(NAME, { filter: { ZakazkaId: this.ZakazkaId } });
		},
		createClickFunc() {
			openEdit(NAME, PageMode.CREATE, { filter: { ZakazkaId: this.ZakazkaId }, ZakaznikId: this.ZakaznikId, VozidloId: this.VozidloId });
		},
		editClick(event: any) {
			openEdit(NAME, PageMode.EDIT, { props: true, id: event.data.ID });
		},
	},
});
